import { render, staticRenderFns } from "./AwardsByDayModal.vue?vue&type=template&id=248a517e&scoped=true&"
import script from "./AwardsByDayModal.vue?vue&type=script&lang=js&"
export * from "./AwardsByDayModal.vue?vue&type=script&lang=js&"
import style0 from "./AwardsByDayModal.vue?vue&type=style&index=0&id=248a517e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a517e",
  null
  
)

export default component.exports